<script setup>
  const props = defineProps( {
    centerImage: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'small'
    },
    alignment: {
      type: String,
      default: null
    },
    showAlignment: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  } )

</script>

<template lang="pug">
  .token-container( :class="[size, { selected: props.selected }]" )
    .token
      .center-image( :style="{ backgroundImage: `url(${props.centerImage})` }" )
      .alignment-indicator( v-if="props.alignment && props.showAlignment" :class="[props.alignment, props.alignment === 'good' ? 'bg-success' : 'bg-danger' ]" )
        font-awesome-icon.text-white( :icon="props.alignment === 'good' ? 'thumbs-up' : 'thumbs-down'")
      svg( viewBox="0 0 150 150" )
        path( :id="props.id" d="M 13 75 C 13 160, 138 160, 138 75" fill="transparent" )
        text( width="150" x="66.6%" text-anchor="middle" class="character__name" )
          textPath( :xlink:href="'#' + props.id" ) {{ name }}
</template>


<style scoped>
  .token-container.small {
    position: relative;
    width: 100px;
    height: 100px;
  }

  .token-container.large {
    position: relative;
    width: 250px;
    height: 250px;
  }

  .token {
    --shadow-offset: 0.1em;
    --shadow-rotation: 1;
    --shadow-amount: calc(var(--shadow-offset)*var(--shadow-rotation));
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: relative;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    box-shadow: inset .1em .1em .2em hsla(0, 0%, 100%, .2), var(--shadow-amount) var(--shadow-amount) .2em rgba(0, 0, 0, .8);
    background-image: url(/tokens/token/TokenBG.png);
  }

  .center-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .alignment-indicator {
    position: absolute;
    right: -5px;
    z-index: 10;
    width: 35%;
    height: 35%;
    border-radius: 50%;
    padding: 10px;
    background-color: rgba(64, 64, 64, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: 100%;
    height: 100%;
  }

  text {
    font-size: 2rem;
    line-height: 2rem;
  }

  .token-container.selected .token::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 5px solid #0077ff;
    border-radius: 50%;
    pointer-events: none;
    z-index: 5;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
  }

  .token-container.selected .character__name {
    fill: white;
    font-weight: bold;
    text-shadow: 2px 2px 3px black, -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
  }
</style>
